import script from "./sceneInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./sceneInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./sceneInfoAdd.vue?vue&type=style&index=0&id=054c12d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054c12d6"]])

export default __exports__